import { connect } from 'react-redux';

import { sessionInitialized } from 'modules/session/selectors/sessionStatus';
import config from 'config';

import Header from './Header';

export default connect(state => ({
  selectedOrganizationToken: state.auth.organizations.selectedOrganizationToken,
  selectedOrganizationLogo: state.auth.organizations.organizationLogo || state.auth.organizations.siteLogo,
  userExist: !!state.auth.userInfo.userId,
  isMoh: config.product_name === 'moh',
  isClalit: config.product_name === 'clalit',
  locationpath: window.location.pathname,
  isSessionInitialized: sessionInitialized(state),
}))(Header);
